import { setupContentBuilder } from 'ricos-content/libs/Content';
import { generateKey } from 'wix-rich-content-common';
import { createEmptyContent } from 'ricos-content/libs/createEmptyContent';
import { TextStyle_TextAlignment } from 'ricos-schema';
const api = setupContentBuilder(generateKey);
export const getCheckoutMessage = text => {
  return api.addParagraph({
    data: {
      textStyle: {
        textAlignment: TextStyle_TextAlignment.CENTER
      }
    },
    text,
    content: {
      ...createEmptyContent(),
      nodes: []
    }
  });
};
//# sourceMappingURL=checkout-message.js.map